import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import {
  getHintVariantStyle,
  HintVariant,
} from 'modules/simulatorTrainings/common/components/common/Hint'

export const SessionListItem = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.large};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.large};
  `}
`

export const SessionListItemHeader = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.base};
  `}
`

export const SessionListItemActions = styled.div`
  display: flex;
  flex-direction: column;

  ${media.sm`
    flex-direction: row;
  `}
`

export const SessionListItemInfoWrapper = styled.div`
  display: flex;
  flex: 1 0;
  flex-wrap: wrap;
  align-items: center;
`

export const SessionListItemInfo = styled.div`
  flex-shrink: 0;
  min-width: 110px;

  ${({ theme }) => `
    margin-right: ${theme.space.mobile.small};
  `}

  &:last-child {
    margin-right: 0;
  }
`

export const SessionListItemInfoLabel = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.nano};
  `}
`

export const SessionListItemSidebar = styled.div`
  flex-shrink: 0;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.small};
  `}

  ${({ theme }) => media.sm`
    margin-left: ${theme.space.mobile.small};
    margin-top: 0;
  `}
`

export const ButtonWrapper = styled.div`
  width: 250px;

  ${media.sm`
    width: 300px;
  `}

  ${media.md`
    width: 190px;
  `}
`

export const PleaseWait = styled.div`
  width: 100%;
  text-align: center;
  cursor: default;

  ${({ theme }) => `
    padding: ${theme.space.mobile.small} ${theme.space.mobile.large};
    color: ${theme.color.oceanLight};
    font-weight: ${theme.fontWeight.semibold};
  `}

  ${({ theme }) => media.sm`
    padding: ${theme.space.desktop.small} ${theme.space.desktop.base};
  `}
`

type WrapperProps = {
  variant?: HintVariant
}

export const Hint = styled.div<WrapperProps>`
  width: 250px;

  ${({ theme, variant }) => `
    ${getHintVariantStyle({ theme, variant })}
    padding: ${theme.space.mobile.tiny} ${theme.space.mobile.base};
    margin-top: -${theme.space.mobile.tiny};
    margin-bottom: ${theme.space.mobile.tiny};
    border-radius: ${theme.borderRadius.base};
    font-family: ${theme.fontFamily.secondary};
    font-weight: ${theme.fontWeight.semibold};
    font-size: ${theme.fontSize.mobile.h3};
    line-height: ${theme.lineHeight.desktop.h3};

    &:after {
      border-top: 20px solid ${theme.color.mustard};
    }
  `}

  ${({ theme }) => media.sm`
    padding: calc(${theme.space.desktop.nano} * 2) ${theme.space.desktop.base};
    width: auto;
  `}
`
